import { combineReducers } from "redux";
import customerReducer from "./customerReducer";
import shoppingCartReducer from "./shoppingCartReducer";
import welcomeReducer from "./welcomeReducer";

const rootReducer = combineReducers({
  customer: customerReducer,
  shoppingCart: shoppingCartReducer,
  welcomeModal: welcomeReducer,
});

export default rootReducer;
